<delete-form
  [width]="width"
  [outerWidth]="outerWidth"
  [title]="title"
  [load]="load"
  [loading]="loading"
  [erred]="erred"
  [submit]="submit"
  [submitting]="submitting"
  [submitText]="submitText"
  [disableDelete]="phrase !== requiredPhrase"
  (close)="close.emit()"
  (submitted)="submitted.emit()"
>
  <div class="rv-grid outer large">
    <ng-content></ng-content>
    <p class="column-small-12">Type "{{ requiredPhrase }}" to proceed.</p>
    <deprecated-text-field
      class="column-small-12"
      [autoFocus]="true"
      [(ngModel)]="phrase"
    ></deprecated-text-field>
  </div>
</delete-form>
